import { render, staticRenderFns } from "./base-list-detail.vue?vue&type=template&id=31c018aa&"
import script from "./base-list-detail.vue?vue&type=script&lang=js&"
export * from "./base-list-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports